import LensCard from "./LensCard.jsx";

export default function LensCardRail({ lenses, favoriteIds, activeLensId, busyLensId, onApply, onFavorite }) {
  return (
    <div className="lens-card-rail">
      {lenses.map((lens) => (
        <LensCard
          key={lens.lensId}
          lens={lens}
          compact
          favorite={favoriteIds.has(lens.lensId)}
          active={activeLensId === lens.lensId}
          busy={busyLensId === lens.lensId}
          onApply={onApply}
          onFavorite={onFavorite}
        />
      ))}
    </div>
  );
}
